import { render } from "./SelectBox.vue?vue&type=template&id=5099e9fc&ts=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"

import "./SelectBox.vue?vue&type=style&index=0&id=5099e9fc&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__